import { Play } from "lucide-react";
import { DEMO_VIDEO } from "@/data/content";
import { useLang } from "@/i18n";
import { trackEvent, EVENTS } from "@/lib/analytics";
import { CTAButton, SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

export const SeeItInAction = () => {
  const { t } = useLang();
  const v = t.deviceVideo;
  return (
    <section id="see-it" data-testid="device-video-section" className="py-16 md:py-24 bg-[#FAFAFC]">
      <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <SectionLabel>{v.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold text-navy-900 leading-tight">{v.title}</h2>
          <p className="mt-4 text-base md:text-lg text-charcoal-700 leading-relaxed max-w-xl mx-auto">{v.text}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 mx-auto max-w-3xl rounded-[1.5rem] p-[3px] bg-gradient-to-br from-gold-500 via-navy-100 to-gold-400 shadow-2xl">
            <div className="relative rounded-[calc(1.5rem-3px)] overflow-hidden bg-navy-900 aspect-video">
              {DEMO_VIDEO.url ? (
                <video
                  controls
                  preload="metadata"
                  poster={DEMO_VIDEO.poster || undefined}
                  className="h-full w-full object-cover"
                  data-testid="demo-video-player"
                  onPlay={() => trackEvent(EVENTS.DEVICE_VIDEO_PLAY)}
                >
                  <source src={DEMO_VIDEO.url} type="video/mp4" />
                  {DEMO_VIDEO.captions && <track kind="captions" src={DEMO_VIDEO.captions} srcLang="en" label="English" />}
                  Your browser does not support the video tag.
                </video>
              ) : (
                <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center" data-testid="demo-video-placeholder">
                  <div className="absolute inset-0 opacity-40" style={{ background: "radial-gradient(60% 80% at 50% 0%, rgba(212,175,55,0.35), transparent 70%)" }} aria-hidden />
                  <span
                    className="relative flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full border-2 border-gold-500/40 bg-white/5 text-gold-500/60 backdrop-blur-sm cursor-not-allowed"
                    aria-disabled="true"
                    aria-label={v.soonLabel}
                  >
                    <Play size={24} aria-hidden className="ml-1" />
                  </span>
                  <p className="relative mt-4 font-display text-lg sm:text-2xl font-semibold text-white">{v.soonLabel}</p>
                </div>
              )}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-8">
            <CTAButton
              href="#contact"
              data-testid="device-video-cta"
              onClick={() => trackEvent(EVENTS.PRIMARY_CTA, { placement: "device_video" })}
              className="w-full sm:w-auto justify-center min-h-[48px]"
            >
              {v.button}
            </CTAButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
